export default __webpack_public_path__ + "static/media/delete_alt.7a68d4c8.svg";